import { render, staticRenderFns } from "./participant-configuration.vue?vue&type=template&id=3323020e&scoped=true&"
import script from "./participant-configuration.vue?vue&type=script&lang=js&"
export * from "./participant-configuration.vue?vue&type=script&lang=js&"
import style0 from "./participant-configuration.vue?vue&type=style&index=0&id=3323020e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3323020e",
  null
  
)

component.options.__file = "participant-configuration.vue"
export default component.exports